import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Vi använder cookies',
    description:
      'Vi använder cookies och liknande tekniker för att tillhandahålla denna upplevelse. Strikt nödvändiga cookies är alltid aktiva.',
    allow_label: 'Acceptera alla cookies',
    reject_label: 'Endast strikt nödvändiga',
    settings_label: 'Cookieinställningar',
    policy_link_label: 'Integritets- och cookiepolicy',
    categories_label: 'Kategorier',
    always_on_label: 'Alltid aktiv',
    required_label: 'Krävs',
    save_preferences_label: 'Spara inställningar',
    close_label: 'Stäng',
    allow_all_optional_categories_label: 'Tillåt alla valfria kategorier',
    settings_title: 'Cookieinställningar',
    settings_description:
      'Vi använder cookies och liknande tekniker för att tillhandahålla denna upplevelse. Strikt nödvändiga cookies är alltid aktiva.',
    save_error: 'Det gick inte att spara ditt integritetsval. Försök igen.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strikt nödvändiga',
      purpose: 'Krävs för att tillhandahålla denna upplevelse och kan inte inaktiveras.'
    },
    analytics: {
      name: 'Analys',
      purpose: 'Mäter hur besökare använder denna upplevelse för att förbättra prestandan.'
    },
    marketing: { name: 'Marknadsföring', purpose: 'Stöder annonsering och marknadsföring som arrangören valt.' }
  }
};

export default locale;
